"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "SVBAllApisCard", {
  enumerable: true,
  get: function get() {
    return _SVBAllApisCard.default;
  }
});
var _SVBAllApisCard = _interopRequireDefault(require("./src/SVBAllApisCard"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }